import React from 'react';
import { Logo } from '../Logo';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-4 pb-28 pt-8 sm:px-6 sm:pb-24" data-id="element-173" data-mp="207kr6mx5mqd0">
      <div className="mx-auto w-full max-w-content border-t border-white/10 pt-7" data-id="element-174" data-mp="207aw4kx95t0g">
        <div className="flex justify-center" data-id="element-175" data-mp="2f4bie8wocvrj">
          <Logo tone="dark" data-id="element-176" data-mp="2a607rvyk2h89" />
        </div>

        <p className="mx-auto mt-5 max-w-lg text-center text-[11.5px] leading-relaxed text-white/45" data-id="element-177" data-mp="2a71u4wl0uq5a">
          El Sistema de Decisión Clínica para Diabetes es material educativo dirigido a profesionales
          de la salud. No sustituye el juicio clínico individual ni la normativa y disponibilidad de
          tratamientos de cada país.
        </p>

        <p className="mt-4 text-center text-[11.5px] font-semibold text-white/35" data-id="element-178" data-mp="1rfituxidtq6y">
          © {new Date().getFullYear()} Dra. Karito • Todos los derechos reservados
        </p>
      </div>
    </footer>;
}